<template>
  <div class="allbox">
    <div class="top_inrwe">
      <div class="condition">
        <!--        <el-input-->
        <!--          v-model="query.name"-->
        <!--          class="inptw"-->
        <!--          placeholder="请输入投放规则名称"-->
        <!--        />-->
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          @click="getList"
        >刷新</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="insert"
        >新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="copy_que_data"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
      />
      <el-table-column
        prop="name"
        label="账号"
      />
      <el-table-column
        prop="nickname"
        label="昵称"
      />
      <el-table-column
        prop="num"
        label="队列数量"
      />
    </el-table>
    <!--    <pagination-right-->
    <!--      :current-page="query.page"-->
    <!--      :total="total"-->
    <!--      @size-change="fetchPageSize"-->
    <!--      @current-change="fetchCurrentPage"-->
    <!--    />-->
    <el-dialog
      title="新增队列"
      :visible.sync="copy_visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px">
        <el-form-item label="管理员账号">
          <el-input
            v-model="name"
            style="width: 300px;margin-left: 5px"
            placeholder="请输入账号"
          />
        </el-form-item>
        <el-form-item label="队列数量">
          <el-input
            v-model="num"
            style="width: 300px;margin-left: 5px"
            placeholder="请输入不大于6的整数"
            @blur="lick"
          />
        </el-form-item>
      </el-form>
      <div style="margin-top: 10px">
        <el-button
          type="success"
          @click="addCopy"
        >确定</el-button>
        <el-button
          type="info"
          @click="copy_visible = false"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import { addCopyQuebsl, getCopyQueueListbsl } from '@/api/customer'
export default {
  components: {
    // PaginationRight
  },
  data() {
    return {
      copy_que_data: null,
      query: {},
      total: 0,
      copy_visible: false,
      num: null,
      name: null,
      loading: false
    }
  },
  computed: {},
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getCopyQueueListbsl().then(res => {
        this.copy_que_data = res.data
        this.loading = false
        console.log(res)
      })
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    insert() {
      this.copy_visible = true
    },
    addCopy() {
      console.log(this.copy_visible)
      if (this.name && this.num) {
        addCopyQuebsl({
          num: this.num,
          name: this.name
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message.success(res.message)
            this.getList()
            this.copy_visible = false
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    lick() {
      if (this.num > 6) {
        this.num = 6
      }
    }
  }
}
</script>

<style lang="less" scoped>
.allbox {
  padding: 30px;
}

.top_inrwe {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inptw {
  width: 250px;
}

.condition > * {
  margin-right: 10px;
}
</style>
